import { useEffect, useState } from 'react';
import { workshopModuleTagApi } from '../../../../entities/module/workshop-module-tag';
import { privateTemplateModuleTagAPI } from '../../../../entities/module/private-template-module-tag/api/api';
import {
	IGetWorkshopTagGroupResponse,
} from '../../../../entities/module/tag-group/workshop-module-tag-group/model/types/types';
import {
	IGetTagGroupResponse,
	ITagsGroup,
} from '../../../../entities/template/private-template-tag-group/template-tag-group/api/types';
import { TypeOfTags } from '../../../modules-modal/private-template-modules-modal/model/types';
import { workshopModuleTagGroupApi } from '../../../../entities/module/tag-group/workshop-module-tag-group';
import { privateTemplateModuleTagGroupAPI } from '../../../../entities/template/private-template-tag-group/template-tag-group/api/privateTemplateModuleTagGroupAPI';
import { TagGroupType } from '../../../../entities/template/private-template-tag-group/model/types';

export const useModuleTagGroupData = (typeOfTags: TypeOfTags, debouncedSearch: string) => {
	const [tagGroups, setTagGroups] = useState<ITagsGroup[]>([]);

	const { isLoading, data: tagGroupsData, refetch: refetchTagGroups } = typeOfTags === TypeOfTags.WORKSHOP_TAGS
		? workshopModuleTagGroupApi.useGetWorkshopGroupsQuery({
			page: 1,
			limit: 127,
			search: debouncedSearch,
		})
		: privateTemplateModuleTagGroupAPI.useGetAllQuery({
			page: 1,
			limit: 127,
			search: debouncedSearch,
		});

	const {
		data: workshopAvailableTags,
		refetch: refetchWorkshopTagsWithoutGroups,
	} = workshopModuleTagApi.useGetTagsWithoutGroupsQuery({
		limit: 127,
		page: 1,
	});

	const {
		data: privateAvailableTags,
		refetch: refetchPrivateAvailableTags,
	} = privateTemplateModuleTagAPI.useGetTagsWithoutGroupsQuery({
		limit: 127,
		page: 1,
	});

	useEffect(() => {
		if (typeOfTags === TypeOfTags.WORKSHOP_TAGS && !isLoading) {
			const workshopData = tagGroupsData as IGetWorkshopTagGroupResponse;

			setTagGroups([
				{
					id: TagGroupType.tagsWithoutGroup,
					name: 'Без группы',
					tags: workshopAvailableTags?.moduleTags || [],
				},
				...(workshopData?.tagGroups || []),
			]);
		} else if (typeOfTags === TypeOfTags.PRIVATE_TAGS && !isLoading) {
			const privateData = tagGroupsData as IGetTagGroupResponse;
			setTagGroups([
				{
					id: TagGroupType.tagsWithoutGroup,
					name: 'Без группы',
					tags: privateAvailableTags?.moduleTags || [],
				},
				...(privateData?.tagGroups || []),
			]);
		}
	}, [typeOfTags, isLoading, tagGroupsData, workshopAvailableTags, privateAvailableTags]);

	return {
		tagGroups,
		refetchTagGroups,
		refetchWorkshopTagsWithoutGroups,
		refetchPrivateAvailableTags,
		privateAvailableTags,
		workshopAvailableTags,
	};
};
